import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../../auth/authRoles'
import PatientData from './patient/PatientData'

const Analytics = Loadable(lazy(() => import('./Analytics')))
const DataTable = Loadable(lazy(() => import('./DataTable')))
const DashboardConfig = Loadable(lazy(() => import('./DashboardConfig')))

const dashboardRoutes = [
    {
        path: '/dashboard',
        element: <Analytics />,
        auth: authRoles.guest,
    },
    {
        path: '/dashboard/default',
        element: <Analytics />,
        auth: authRoles.guest,
    },
    {
        path: '/dashboard/data-table',
        element: <DataTable />,
        auth: authRoles.guest,
    },
    {
        path: '/dashboard/patient/:cid',
        element: <PatientData />,
        auth: authRoles.guest,
    },
    {
        path: '/admin/dashboard_setting',
        element: <DashboardConfig />,
        auth: authRoles.admin,
    },
]

export default dashboardRoutes
